import React, { useEffect, useState } from "react";
import PillButton from "./button/Pills";
import usersApi from "../services/users/UserApi";
import CommonHeader from "./CommonHeader";
import ToastNotification, { showToast } from "./Toaster";

const DefaultConfig = () => {
  const [config, setConfig] = useState<any>();

  const normalizeGenericPrompt = (value: unknown): string => {
    if (typeof value === "string") return value;
    if (value === null || value === undefined) return "";

    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return String(value);
    }
  };

  useEffect(() => {
    const fetchUserConfig = async () => {
      try {
        const response = await usersApi.getDefaultConfig(1);
        if (response.success) {
          const defaultConfigData = response.value.data as any;
          setConfig({
            ...defaultConfigData,
            genericPrompt: normalizeGenericPrompt(defaultConfigData?.genericPrompt),
          });
          console.log("response.value L ", response.value);
        } else {
          console.error("Failed to fetch user config:", response.error.message);
        }
      } catch (error) {
        console.error("Error fetching user config:", error);
      }
    };

    fetchUserConfig();
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const target = e.target;
    const { name, value } = target;

    let nextValue: string | boolean = value;
    if (target instanceof HTMLInputElement && target.type === "checkbox") {
      nextValue = target.checked;
    }

    setConfig((prevConfig: any) => ({
      ...prevConfig,
      [name]: nextValue,
    }));
  };

  const handleSave = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log("Configuration saved: " + JSON.stringify(config, null, 2));
    try {
      const response = await usersApi.setDefaultConfig({
        ...config,
        trialPeriod: config?.trialPeriod,
        disableAssistantTimer: config?.disableAssistantTimer,
        genericPrompt: normalizeGenericPrompt(config?.genericPrompt),
      });
      if (response.success) {
        showToast("Configuration saved successfully!", "success");
      } else {
        console.error("Failed to save user config:", response.error.message);
      }
    } catch (error) {
      console.error("Error saving user config:", error);
    }
  };

  return (
    <div className="flex h-screen">
      <ToastNotification />
      <div className="flex-1 flex flex-col">
        <div className="h-20 bg-white">
          <CommonHeader title="User Default Configuration" />
          </div> 
        <main className="flex-grow mx-4 sm:mx-10 md:mx-20 lg:mx-60 my-10 p-4 sm:p-6 md:p-8 shadow-sm border border-ez-border dark:border-ez-border bg-white dark:bg-ez-surface rounded-2xl">
          <form onSubmit={handleSave} className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-ez-text-primary">
                  Group Members Size
                </label>
                <input
                  type="number"
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  name="groupMembersSize"
                  value={config?.groupMembersSize}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-ez-border bg-white text-ez-text-primary dark:bg-ez-elevated dark:text-ez-text-primary dark:border-ez-border"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-ez-text-primary">
                  Max SMS Length
                </label>
                <input
                  type="number"
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  name="maxSmsLength"
                  value={config?.maxSmsLength}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-ez-border bg-white text-ez-text-primary dark:bg-ez-elevated dark:text-ez-text-primary dark:border-ez-border"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-ez-text-primary">
                  Max MMS Length
                </label>
                <input
                  type="number"
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  name="maxMmsLength"
                  value={config?.maxMmsLength}
                  onChange={handleChange}
                  className="mt-1 block dark:bg-gray-800 dark:text-ez-text-primary w-full border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-ez-text-primary">
                  Max Contacts
                </label>
                <input
                  type="number"
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  name="maxContacts"
                  value={config?.maxContacts}
                  onChange={handleChange}
                  className="mt-1 block dark:bg-gray-800 dark:text-ez-text-primary w-full border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-ez-text-primary">
                  Max Groups
                </label>
                <input
                  type="number"
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  name="maxGroups"
                  value={config?.maxGroups}
                  onChange={handleChange}
                  className="mt-1 block dark:bg-gray-800 dark:text-ez-text-primary w-full border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-ez-text-primary">
                  Max Messages Per Day
                </label>
                <input
                  type="number"
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  name="maxMessagesPerDay"
                  value={config?.maxMessagesPerDay}
                  onChange={handleChange}
                  className="mt-1 block dark:bg-gray-800 dark:text-ez-text-primary w-full border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-ez-text-primary">
                  Max Campaigns
                </label>
                <input
                  type="number"
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  name="maxCampaigns"
                  value={config?.maxCampaigns}
                  onChange={handleChange}
                  className="mt-1 block dark:bg-gray-800 dark:text-ez-text-primary w-full border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-ez-text-primary">
                  Trial Period (Days)
                </label>
                <input
                  type="number"
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  name="trialPeriod"
                  value={config?.trialPeriod}
                  onChange={handleChange}
                  className="mt-1 block dark:bg-gray-800 dark:text-ez-text-primary w-full border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-ez-text-primary">
                  Disable Assistant Timer (Seconds)
                </label>
                <input
                  type="number"
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  name="disableAssistantTimer"
                  value={config?.disableAssistantTimer}
                  onChange={handleChange}
                  className="mt-1 block dark:bg-gray-800 dark:text-ez-text-primary w-full border-gray-300 rounded-md"
                />
              </div>
              <div className="flex items-end pb-3">
                
                <input
                  type="checkbox"
                  name="recurringCampaignsEnabled"
                  checked={config?.recurringCampaignsEnabled}
                  onChange={handleChange}
                  className="mr-2"
                />
                <label className="text-sm font-medium text-gray-700 dark:text-ez-text-primary">
                  Recurring Campaigns Enabled
                </label>
              </div>
            </div>
           
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-ez-text-primary mb-2">
                Generic Prompt
              </label>
              <textarea
                name="genericPrompt"
                value={config?.genericPrompt ?? ""}
                onChange={handleChange}
                rows={8}
                placeholder="Enter generic prompt..."
                className="mt-1 block w-full rounded-md border border-ez-border bg-white px-3 py-2 text-ez-text-primary placeholder:text-ez-text-muted dark:bg-ez-elevated dark:text-ez-text-primary dark:border-ez-border focus:outline-none focus:ring-2 focus:ring-ez-border-strong"
              />
            </div>
             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  name="smsEnabled"
                  checked={config?.smsEnabled}
                  onChange={handleChange}
                  className="mr-2"
                />
                <label className="text-sm font-medium text-gray-700 dark:text-ez-text-primary">
                  SMS Enabled
                </label>
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  name="mmsEnabled"
                  checked={config?.mmsEnabled}
                  onChange={handleChange}
                  className="mr-2"
                />
                <label className="text-sm font-medium text-gray-700 dark:text-ez-text-primary">
                  MMS Enabled
                </label>
              </div>
            </div>
            <div className="flex justify-center pt-4 pb-4">
              <PillButton
                type="submit"
                variant="dark"
                className="!bg-violet-600 !border-violet-600 hover:!bg-violet-700 hover:!border-violet-700 dark:!bg-violet-600 dark:!border-violet-600 dark:hover:!bg-violet-700 dark:hover:!border-violet-700"
              >
                Update
              </PillButton>
            </div>
          </form>
        </main>
      </div>
    </div>
  );
};

export default DefaultConfig;



